
const CryptoDetailTypes = {
    setCryptoDetailList: 'SET_CRYPTO_DETAIL_LIST',
    updateCryptoDetailList: 'UPDATE_CRYPTO_DETAIL_LIST',
    errorCryptoDetail: 'ERROR_CRYPTO_DETAIL',
    changeFavorite: 'CHANGE_FAVORITE',
};

export default CryptoDetailTypes;